import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.users');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';
import { cloneDeep } from 'lodash';

@Component({
    selector: 'wiz-page-admin-users',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.users/view.scss */
/* src/app/page.admin.users/view.scss: no such file or directory */`],
})
export class PageAdminUsersComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public pagenation: any = {
        page: 1,
        end: 1,
        start: 1,
    };

    public mode: any;
    public searchTerm: any;
    public users: any = [];
    public dump: any = "10";
    public activeTotal: any;
    public blockTotal: any;
    public pendingTotal: any;

    public sortColumn: any = "name";
    public sortDirection: any = "ASC";

    public addOpen: boolean = false;
    public blockOpen: boolean = false;
    public contactOpen: boolean = false;
    public selectedUser: any = {};
    public addUserInfo: any = {};
    public addContactInfo: any = {};
    public reason: any;

    public institutes: any = [];
    public networks: any = [];

    public tabs = [
        { key: 'active', label: '가입된 사용자', count: 0 },
        { key: 'contact', label: '기관/회선 담당자', count: 0 },
        { key: 'pending', label: '대기', count: 0 },
        { key: 'block', label: '차단', count: 0 }
    ];
    public activeTab: any = "active";

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('admin', '/');
        this.title.setTitle("사용자 관리 - MY KREONET");
        await this.load();
        await this.institute();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { mode: this.activeTab, text: this.searchTerm, page: this.pagenation.page, dump: this.dump, order: this.sortDirection, orderby: this.sortColumn });
        if (code != 200) return await this.service.alert.error("Error!");
        this.users = data.users;
        this.pagenation.start = (parseInt(this.pagenation.page / 11) * 10) + 1;
        this.pagenation.end = data.lastpage;
        this.tabs[0].count = data.active;
        this.tabs[1].count = data.contact;
        this.tabs[2].count = data.pending;
        this.tabs[3].count = data.block;
        await this.service.render();
    }

    public async addUser(person: any) {
        const text = person.name + "님을 추가하시겠습니까?"
        const res = await this.service.alert.success(text);
        person.password = this.service.auth.hash(person.password);
        if (res) {
            const { code, data } = await wiz.call("addUser", person);
            if (code != 200) return await this.service.alert.error("Error!");
            await this.service.alert.success("추가되었습니다.");
            this.addUserInfo = {};
            this.addOpen = false;
            await this.load();
        }
    }

    public async addContact(person: any) {
        const text = person.name + "님을 기관/회선 담당자에 추가하시겠습니까?"
        const res = await this.service.alert.success(text);
        const selectedNetwork = this.networks.find(net => net.name === person.network);
        if (res) {
            const { code, data } = await wiz.call("addContact", { contact: JSON.stringify(person), netID: selectedNetwork.id });
            if (code != 200) return await this.service.alert.error("Error!");
            await this.service.alert.success("추가되었습니다.");
            this.addContactInfo = {};
            this.contactOpen = false;
            await this.load();
        }
    }

    public async activeUser(person: any) {
        const text = person.name + "님의 가입을 승인하시겠습니까?"
        const res = await this.service.alert.success(text);
        if (res) {
            const { code, data } = await wiz.call("activeUser", person);
            if (code != 200) return await this.service.alert.error("Error!");
            await this.service.alert.success("승인되었습니다.");
            await this.load();
        }
    }

    public async blockUser(person: any) {
        if (!this.reason || this.reason == "") return await this.service.alert.warning("사유를 입력해주세요.");
        const text = person.name + "님을 차단하시겠습니까?"
        const res = await this.service.alert.error(text);
        person.reason = this.reason;
        if (res) {
            const { code, data } = await wiz.call("blockUser", person);
            if (code != 200) return await this.service.alert.error("Error!");
            this.reason = "";
            delete person.reason;
            this.blockOpen = false;
            await this.service.alert.success("차단되었습니다.");
            await this.load();
        }
    }

    public async editUser(person: any) {
        const text = person.name + "님의 정보를 수정하시겠습니까?"
        const res = await this.service.alert.warning(text);
        this.networks = [];
        await this.service.render();
        if (res) {
            const api =
                (this.activeTab === 'active' || this.activeTab === 'pending' || this.activeTab === 'block') ? 'editUser' :
                this.activeTab === 'contact' ? 'editContact' :
                null;
            const { code, data } = await wiz.call(api, person);
            if (code != 200) return await this.service.alert.error("Error!");
            await this.service.alert.success("수정되었습니다.");
            this.editOpen = false;
            await this.load();
        }
    }

    public async deleteUser(person: any) {
        const text = person.name + "님을 삭제하시겠습니까?"
        const res = await this.service.alert.error(text);
        if (res) {
            const { code, data } = await wiz.call("deleteUser", { userID: person.id });
            if (code != 200) return await this.service.alert.error("Error!");
            await this.service.alert.error("삭제되었습니다.");
            await this.load();
        }
    }

    public async institute() {
        const { code, data } = await wiz.call("institute");
        if (code != 200) return await this.service.alert.error("Error!");
        this.institutes = data;
        if (this.selectedUser?.institute) {
            await this.loadNetworksByInstituteName(this.selectedUser.institute);
        }
        await this.service.render();
    }

    public async onInstituteChange(event: any) {
        const name = event?.target?.value ?? this.selectedUser.institute ?? '';
        await this.loadNetworksByInstituteName(name);
        // const selectedInstitute = this.institutes.find(ins => ins.name === event.target.value);
        // const { code, data } = await wiz.call("network", { insID: selectedInstitute.id });
        // if (code != 200) return await this.service.alert.error("Error!");
        // this.networks = data;
        // await this.service.render();
    }

    // 공통 헬퍼: 기관 이름으로 회선 불러오기
    private async loadNetworksByInstituteName(insName: string) {
        const ins = this.institutes.find(i => i.name === insName);
        if (!ins) {
            this.networks = [];
            this.selectedUser.network = '';
            await this.service.render();
            return;
        }

        const { code, data } = await wiz.call("network", { insID: ins.id });
        if (code !== 200) return await this.service.alert.error("Error!");

        this.networks = data || [];

        // 현재 선택된 network가 목록에 없으면 초기화
        const exists = this.networks.some(n => (n.name || n) === this.selectedUser.network);
        if (!exists) this.selectedUser.network = '';

        await this.service.render();
    }

    public async sortBy(column: string) {
        if (this.sortColumn === column) {
            this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sortColumn = column;
            this.sortDirection = "ASC";
        }
        await this.load();
    }

    public tabChange(tab: string) {
        this.activeTab = tab;
        this.pagenation.page = 1;
        this.load();
    }

    public dumpChange(dump: string) {
        this.dump = dump;
        this.pagenation.page = 1;
        this.load();
    }

    private async pageLoad(p: number) {
        this.pagenation.page = p;
        await this.load();
    }

    private async modal(mode: any, person: any) {
        if (mode == 'active') {
            this.addOpen = !this.addOpen;
            this.addUserInfo = {};
        }
        else if (mode == 'block') {
            this.blockOpen = !this.blockOpen;
            this.selectedUser = person;
        }
        else if (mode == 'edit') {
            this.editOpen = !this.editOpen;
            this.selectedUser = cloneDeep(person);
            if (this.activeTab == 'contact' && this.editOpen == true) await this.loadNetworksByInstituteName(this.selectedUser.institute)
        }
        else if (mode == 'contact') {
            this.contactOpen = !this.contactOpen;
            this.addContactInfo = {};
        }
        this.filteredInstitutes = [];
        await this.service.render();
    }

    // textarea Height
    public autoResize(event: Event) {
        const textarea = event.target as HTMLTextAreaElement;
        textarea.style.height = 'auto'; // 높이 초기화
        textarea.style.height = textarea.scrollHeight + 'px'; // 실제 내용 높이만큼 확장
    }

    public filteredInstitutes: any[] = [];

    public filterInstitutes(query: string) {
        this.filteredInstitutes = this.institutes.filter(ins =>
            ins.name.includes(query)
        );
        this.service.render();
    }

    public selectInstitute(name: string, ins: any) {
        if (ins == "addContact") this.addContactInfo.institute = name;
        else if (ins == "addUser") this.addUserInfo.institute = name;
        else this.selectedUser.institute = name;

        this.filteredInstitutes = []; // 선택 후 드롭다운 닫기

        this.loadNetworksByInstituteName(name);
        this.service.render();
    }
    public closeDropdown() {
        this.filteredInstitutes = [];
    }
    public openDropdown() {
        this.filterInstitutes(this.selectedUser?.institute ?? '');
        this.service.render(); // 필요 환경이면
    }
}

export default PageAdminUsersComponent;